export default __webpack_public_path__ + "static/media/569.044a2dcd.png";